export const FundsTransferValidators = {
  amount: (v) => {
    if (!v) return "Amount is required";
    if (isNaN(v)) return "Amount must be a number";
    if (Number(v) < 10) return "Amount must be at least KSh 10";
    if (Number(v) > 250000) return "Amount must not exceed KSh 250,000";
    return null;
  },

  selectedPayoutAccountId: (v) => {
    if (!v) return "Please select a payout account";
    return null;
  },
};
